<template>
  <form @submit.prevent="productsFilter" class="in-products-filter mb-5 ">
    <section class=" box-shaddow20 p-3 bg-white mb-3 border-radius15">
     <div class="d-flex justify-content-between align-items-center mb-2" style="border-bottom: 1px solid #dee2e6!important;">
      <h6 class="mr-2 fontsize-medium weight-bold text-color-theme mt-3"> انتخاب یا ورود برند</h6>
      <span>
        <svg width="18" height="18" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M6.294 8.84918C6.17733 8.84918 6.0665 8.80252 5.98483 8.72085L4.57316 7.30918C4.404 7.14002 4.404 6.86002 4.57316 6.69085C4.74233 6.52168 5.02233 6.52168 5.1915 6.69085L6.294 7.79335L8.80233 5.28502C8.9715 5.11585 9.2515 5.11585 9.42066 5.28502C9.58983 5.45418 9.58983 5.73418 9.42066 5.90335L6.60316 8.72085C6.5215 8.80252 6.41066 8.84918 6.294 8.84918Z" fill="#22af61"/>
          <path d="M6.99985 13.2709C6.63235 13.2709 6.26485 13.1484 5.97902 12.9034L5.05735 12.11C4.96402 12.0284 4.73068 11.9467 4.60818 11.9467H3.60485C2.74152 11.9467 2.04152 11.2467 2.04152 10.3834V9.38585C2.04152 9.26335 1.95985 9.03585 1.87818 8.94252L1.09068 8.01502C0.61235 7.44919 0.61235 6.55669 1.09068 5.99085L1.87818 5.06335C1.95985 4.97002 2.04152 4.74252 2.04152 4.62002V3.61669C2.04152 2.75335 2.74152 2.05335 3.60485 2.05335H4.61402C4.73652 2.05335 4.96985 1.96585 5.06318 1.89002L5.98485 1.09669C6.55652 0.606687 7.44902 0.606687 8.02068 1.09669L8.94235 1.89002C9.03568 1.97169 9.26902 2.05335 9.39152 2.05335H10.3832C11.2465 2.05335 11.9465 2.75335 11.9465 3.61669V4.60835C11.9465 4.73085 12.034 4.96419 12.1157 5.05752L12.909 5.97919C13.399 6.55085 13.399 7.44335 12.909 8.01502L12.1157 8.93669C12.034 9.03002 11.9465 9.26335 11.9465 9.38585V10.3775C11.9465 11.2409 11.2465 11.9409 10.3832 11.9409H9.39152C9.26902 11.9409 9.03568 12.0284 8.94235 12.1042L8.02068 12.8975C7.73485 13.1484 7.36735 13.2709 6.99985 13.2709ZM3.60485 2.92835C3.22568 2.92835 2.91652 3.23752 2.91652 3.61669V4.61419C2.91652 4.94669 2.75902 5.37252 2.54318 5.62335L1.75568 6.55085C1.55152 6.79002 1.55152 7.20419 1.75568 7.44335L2.54318 8.37085C2.75902 8.62752 2.91652 9.04752 2.91652 9.38002V10.3775C2.91652 10.7567 3.22568 11.0659 3.60485 11.0659H4.61402C4.95235 11.0659 5.37818 11.2234 5.63485 11.445L6.55652 12.2384C6.79568 12.4425 7.21568 12.4425 7.45485 12.2384L8.37652 11.445C8.63318 11.2292 9.05902 11.0659 9.39735 11.0659H10.389C10.7682 11.0659 11.0774 10.7567 11.0774 10.3775V9.38585C11.0774 9.04752 11.2349 8.62169 11.4565 8.36502L12.2499 7.44335C12.454 7.20419 12.454 6.78419 12.2499 6.54502L11.4565 5.62335C11.2349 5.36669 11.0774 4.94085 11.0774 4.60252V3.61669C11.0774 3.23752 10.7682 2.92835 10.389 2.92835H9.39735C9.05902 2.92835 8.63318 2.77085 8.37652 2.54919L7.45485 1.75585C7.21568 1.55169 6.79568 1.55169 6.55652 1.75585L5.63485 2.55502C5.37818 2.77085 4.94652 2.92835 4.61402 2.92835H3.60485Z" fill="#22af61"/>
          </svg>
          
          
      </span>
     </div>
      <input type="text" v-model="filter.title" placeholder="عنوان جستجو را بنویسید"
             class=" py-2 px-3  border-radius10 bg-color-f9  w-100 fontsize-small">
    </section>
    <section v-if="sizeFilters && sizeFilters.length" class="  box-shaddow20 p-3 bg-white mb-3">
      <div class="text-right border-bottom mb-3">
        <h6 class="mr-2 fontsize-medium weight-bold text-color-theme mt-3">سایز</h6>
      </div>
      <div class="d-flex flex-wrap">
        <div class="size-item" v-for="(size,index) in sizeFilters" :key="index">
        <label class="text-color-666  d-flex align-items-center" v-if="size" style="line-height:1.9">
          <span class="fontsize-small">{{ size.value }}</span>
          <b-form-checkbox v-model="filter.selected_sizes[index]" class="size-label" :unchecked-value="false"/>
        </label>
        <b-skeleton v-else class="ml-2 d-inline-block size-skeleton"/>
      </div>
      </div>
    </section>
<!--    <section v-if="!colors || (colors && colors.length)" class="  box-shaddow20 p-3 bg-white mb-3">-->
<!--      <div class="text-right border-bottom mb-3">-->
<!--        <h6 class="mr-2 fontsize-medium weight-bold text-color-444 mt-3">رنگ</h6>-->
<!--      </div>-->
<!--      <div class="d-flex flex-wrap">-->
<!--        <div v-if="colors && filter && filter.color_ids">-->
<!--          <treeselect-->
<!--              :searchable="true"-->
<!--              :multiple="true"-->
<!--              :options="colors"-->
<!--              noChildrenText="فرزندی وجود ندارد" noOptionsText="موردی وجود ندارد" noResultsText="موردی یافت نشد"-->
<!--              placeholder="انتخاب رنگ ها"-->
<!--              v-model="filter.color_ids"-->
<!--          >-->
<!--            <label :style="'height: 40px'"-->
<!--                   slot="option-label" slot-scope="{ node, labelClassName }" :class="labelClassName">-->
<!--              <div class="color-option-img" :style="'background-color:' + node.raw.code"></div>-->
<!--              {{ node.label }}-->
<!--            </label>-->
<!--          </treeselect>-->
<!--        </div>-->
<!--        <b-skeleton v-else />-->
<!--      </div>-->
<!--    </section>-->
    <section class=" box-shaddow20 p-3 bg-white mb-3 border-radius15">
      <div class="text-right border-bottom pb-2 d-flex justify-content-between align-items-center">
        <h6 class="mr-2 fontsize-medium weight-bold text-color-theme">حالت نمایش</h6>
        <span>
          <svg width="16" height="16" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9.5 5.375H8.5C7.29 5.375 6.625 4.71 6.625 3.5V2.5C6.625 1.29 7.29 0.625 8.5 0.625H9.5C10.71 0.625 11.375 1.29 11.375 2.5V3.5C11.375 4.71 10.71 5.375 9.5 5.375ZM8.5 1.375C7.71 1.375 7.375 1.71 7.375 2.5V3.5C7.375 4.29 7.71 4.625 8.5 4.625H9.5C10.29 4.625 10.625 4.29 10.625 3.5V2.5C10.625 1.71 10.29 1.375 9.5 1.375H8.5Z" fill="#22af61"/>
            <path d="M3.5 11.375H2.5C1.29 11.375 0.625 10.71 0.625 9.5V8.5C0.625 7.29 1.29 6.625 2.5 6.625H3.5C4.71 6.625 5.375 7.29 5.375 8.5V9.5C5.375 10.71 4.71 11.375 3.5 11.375ZM2.5 7.375C1.71 7.375 1.375 7.71 1.375 8.5V9.5C1.375 10.29 1.71 10.625 2.5 10.625H3.5C4.29 10.625 4.625 10.29 4.625 9.5V8.5C4.625 7.71 4.29 7.375 3.5 7.375H2.5Z" fill="#22af61"/>
            <path d="M3 5.375C1.69 5.375 0.625 4.31 0.625 3C0.625 1.69 1.69 0.625 3 0.625C4.31 0.625 5.375 1.69 5.375 3C5.375 4.31 4.31 5.375 3 5.375ZM3 1.375C2.105 1.375 1.375 2.105 1.375 3C1.375 3.895 2.105 4.625 3 4.625C3.895 4.625 4.625 3.895 4.625 3C4.625 2.105 3.895 1.375 3 1.375Z" fill="#22af61"/>
            <path d="M9 11.375C7.69 11.375 6.625 10.31 6.625 9C6.625 7.69 7.69 6.625 9 6.625C10.31 6.625 11.375 7.69 11.375 9C11.375 10.31 10.31 11.375 9 11.375ZM9 7.375C8.105 7.375 7.375 8.105 7.375 9C7.375 9.895 8.105 10.625 9 10.625C9.895 10.625 10.625 9.895 10.625 9C10.625 8.105 9.895 7.375 9 7.375Z" fill="#22af61"/>
            </svg>
            
        </span>
      </div>
      <!-- <div class="mt-3 py-2 border-bottom d-flex">
        <label class="switch ">
          <input type="checkbox" name="x1">
          <span class="slider round"></span>
        </label>
        <span class="fontsize13 text-color-666 mr-2">
          فقط کالاهای اصل
        </span>
      </div> -->
      <div class="mt-3 py-2 d-flex justify-content-between align-items-center">
        <span class="fontsize-small text-color-666 mr-2">
          فقط کالاهای موجود
      </span>
        <label class="switch">
          <input type="checkbox" name="x1" v-model="filter.available">
          <span class="slider round"></span>
        </label>
   
      </div>
    </section>
    <!-- <section class=" box-shaddow20 p-3 bg-white mb-3 border-radius15">
      <div class="d-flex justify-content-between align-items-center" style="border-bottom: 1px solid #dee2e6!important;">

    
      <h6 class="mr-2 fontsize-medium weight-bold text-color-theme ">
        تعیین محدوده قیمت 
        
      </h6>
      <span>
        <svg width="18" height="18" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M7.81676 10.1617H6.35259C5.39592 10.1617 4.62009 9.35665 4.62009 8.36498C4.62009 8.12582 4.81842 7.92748 5.05759 7.92748C5.29676 7.92748 5.49509 8.12582 5.49509 8.36498C5.49509 8.87249 5.88009 9.28665 6.35259 9.28665H7.81676C8.19592 9.28665 8.51092 8.94832 8.51092 8.53999C8.51092 8.03249 8.33009 7.93332 8.03259 7.82832L5.68176 6.99998C5.22676 6.84248 4.61426 6.50415 4.61426 5.45998C4.61426 4.56165 5.32009 3.83832 6.18342 3.83832H7.64759C8.60426 3.83832 9.38009 4.64332 9.38009 5.63498C9.38009 5.87415 9.18176 6.07248 8.94259 6.07248C8.70342 6.07248 8.50509 5.87415 8.50509 5.63498C8.50509 5.12748 8.12009 4.71332 7.64759 4.71332H6.18342C5.80426 4.71332 5.48926 5.05165 5.48926 5.45998C5.48926 5.96748 5.67009 6.06665 5.96759 6.17165L8.31842 6.99998C8.77343 7.15748 9.38592 7.49582 9.38592 8.53999C9.38009 9.43249 8.68009 10.1617 7.81676 10.1617Z" fill="#22af61"/>
          <path d="M7 10.9375C6.76083 10.9375 6.5625 10.7392 6.5625 10.5V3.5C6.5625 3.26083 6.76083 3.0625 7 3.0625C7.23917 3.0625 7.4375 3.26083 7.4375 3.5V10.5C7.4375 10.7392 7.23917 10.9375 7 10.9375Z" fill="#22af61"/>
          <path d="M6.99984 13.2709C3.54067 13.2709 0.729004 10.4592 0.729004 7.00002C0.729004 3.54085 3.54067 0.729187 6.99984 0.729187C10.459 0.729187 13.2707 3.54085 13.2707 7.00002C13.2707 10.4592 10.459 13.2709 6.99984 13.2709ZM6.99984 1.60419C4.02484 1.60419 1.604 4.02502 1.604 7.00002C1.604 9.97502 4.02484 12.3959 6.99984 12.3959C9.97484 12.3959 12.3957 9.97502 12.3957 7.00002C12.3957 4.02502 9.97484 1.60419 6.99984 1.60419Z" fill="#22af61"/>
          </svg>
          
      </span>
    </div>
      <vue-slider class=" mx-2 my-4" ref="slider" v-model="priceRange" :tooltip="'none'"
                  :max="minMax ? minMax : 50000" :interval="step" direction="rtl">
      </vue-slider>
      <div  class="fontsize-mini d-flex flex-wrap justify-content-between">
        <div class="ml-3">
          <span class="text-color-444 ml-1">از قیمت:</span>
          <span class="text-color-666" v-if="priceRange[0] != 0">{{ priceRange[0] | price }} تومان</span>
          <span class="text-color-666" v-else>0 تومان</span>
        </div>
        <div>
          <span class="text-color-444 ml-1">تا</span>
          <span class="text-color-666">{{ priceRange[1] | price }} تومان</span>
        </div>

      </div>
    </section> -->
    <button type="submit" :disabled="loading || disabled"
            class="fontsize-small weight-bold text-white bg-color-theme6 py-2 px-3 w-100 border-r-25">
      اعمال فیلتر
    </button>
  </form>
</template>
<script>
import cloneDeep from 'lodash/cloneDeep'
import {Treeselect} from '@riophae/vue-treeselect'
import {BSkeleton, BFormCheckbox} from 'bootstrap-vue'

export default {
  name: 'ProductsFilter',
  props: {
    value: Object,
    loading: {
      default: false,
      type: Boolean
    }
  },
  components: {
    Treeselect,BSkeleton, BFormCheckbox
  },
  data() {
    return {
      priceRange: [0, 2000000],
      step: 1000,
      filter: cloneDeep(this.value),
    }
  },
  watch: {
    value: {
      handler: function (newVal){
        this.filter = cloneDeep(newVal)
      },
      deep: true
    },
    minMax(newVal) {
      this.$set(this.priceRange, 1 , newVal)
    }
  },
  computed: {
    disabled() {
      return this.$store.getters['front/getProductsStatus']
    },
    minMax() {
      return this.$store.getters['front/getProductsMaxPrice']
    },
    sizeFilters() {
      return this.$store.getters['front/getSizeValues'] ? this.$store.getters['front/getSizeValues'].values
          : Array(6).fill(null)
    },
    colors() {
      return this.$store.getters['front/getColors'] ? this.$store.getters['front/getColors']
          : null
    }
  },
  created() {
    if (this.minMax) {
      this.priceRange = [0, this.minMax];
    }
  },
  methods: {
    productsFilter() {
      this.filter.page = 1
      this.filter.max_price = this.priceRange[1]
      this.filter.min_price = this.priceRange[0]
      this.filter.available ? this.filter.available = 1 : this.filter.available = 0
      this.$emit('input', this.filter)
    }
  }
}
</script>
<style scoped>
.color-option {
  background: black;
}
.color-option-img {
  height: 24px;
  width: 24px;
  border-radius: 50%;
  display: inline-block;
  vertical-align: bottom;
  margin-left: 5px;
}

.size-label {
  display: inline;
  margin-right: 2px;
}

.size-item {
  /* display: inline; */
  margin-left: 5px;
}

.size-skeleton {
  width: 35px;
}
</style>
<style>
.vue-slider-dot {
  cursor: pointer;
}

.in-products-filter .custom-control-input:focus ~ .custom-control-label::before {
  box-shadow: 0 0 0 0.13rem rgb(222 222 222);
}

.in-products-filter .custom-control-input:checked ~ .custom-control-label::before {
  color: #fff;
  border-color: #a07f5c;
  background-color: #121314;
}
</style>
